export const coreAddresses = {
  balanceTracker: "0xe6E4687C35429942391AfE42CDdECba857531492",
  eVaultFactory: "0xF075cC8660B51D0b8a4474e3f47eDAC5fA034cFB",
  eVaultImplementation: "0x11f95aaa59F1AD89576c61E3C9Cd24DF1FdCF46f",
  eulerEarnFactory: "0x3397ec7d28cF645A017869Fe4B41c75f5B0b75a8",
  evc: "0x4860C903f6Ad709c3eDA46D3D502943f184D4315",
  permit2: "0xB952578f3520EE8Ea45b7914994dcf4702cEe578",
  protocolConfig: "0xc2f9FE90bd17e017898b6EfDaa73c34Fddde299e",
  sequenceRegistry: "0x6F417AaEc1D41dB692307269acDA019Ce5F10b0e",
} as const
